module.exports = {
    model: {
        // potential fieldConfig values set within cms_templateAtoms.config
        // config: {
        //     fields: {
        //          sendConfirmation: {
        //             disabled: false
        //          }
        //     }
        //     sendConfirmationOnChange: true, // should this field be marked as sendConfirmation if the value changes?
        //     separatedFieldCodes: {
        //         mobile: 'mobile',
        //         mobileConfirmed: 'mobileConfirmed',
        //         mobileConfirmedAt: 'mobileConfirmedAt',
        //         mobileConfirmationSentAt: 'mobileConfirmationSentAt',
        //     }
        // }
        dataJSON: {},
        sendMobileConfirmation: false
    },

    events: {
        sendConfirmation: {
            type: 'click',
            selector: 'button',
            action: function(event){
                event.stopImmediatePropagation();
                const self = event.data.component;
                const $target = $(event.target).closest('button');
                const fieldType = $target.data('fieldType')

                if(fieldType === 'sendConfirmation'){
                    self.toggleSendConfirmation()
                }
            }
        },

        onChange: {
            type: 'change',
            action: function(event){
                event.preventDefault();
                event.stopImmediatePropagation();

                const self = event.data.component;
                self.updateValue(self.$.find('input[type="text"]').val(), true)
            }
        },
    },

    methods: {
        toggleSendConfirmation(forceValue){
            const fieldConfig = this.model.config || {}
            const fieldsConfig = fieldConfig.fields || {}
            if((fieldsConfig.sendConfirmation || {}).disabled) return;

            if(forceValue === undefined){
                this.model.sendMobileConfirmation = !this.model.sendMobileConfirmation
            } else {
                this.model.sendMobileConfirmation = forceValue
            }
            this.triggerClosest('onChildChanged', {
                fieldCode: 'mobileMeta',
                value: {
                    sendMobileConfirmation: this.model.sendMobileConfirmation
                }
            })
            this.refresh(false)
        },

        updateValue: function(value, tellParents){
            let valueChanged = false;
            if(value !== undefined){
                if(!value) value = null;
                valueChanged = this.model.dataJSON.mobile !== value;
                this.model.dataJSON.mobile = value;
            }

            if(valueChanged){
                this.model.dataJSON.mobileConfirmed = false
                this.model.dataJSON.mobileConfirmedAt = null
                this.model.dataJSON.mobileConfirmationSentAt = null

                if(tellParents && this.model.dataJSON.mobile !== undefined){
                    this.triggerClosest('onChildChanged', {
                        fieldCode: this.model.fieldCode,
                        value: this.model.dataJSON
                    });
                }

                if((this.model.config || {}).sendConfirmationOnChange !== false){
                    this.toggleSendConfirmation(!!value)
                }
            }
        }
    },
}